/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { StorePayingInputDto } from '../model/storePayingInputDto';
import { StorePayingOutputDto } from '../model/storePayingOutputDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
    providedIn:'root'
})
export class StorePayingService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdStore 
     * @param dtFrom 
     * @param dtTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStorePayingGetStoreLiquidationsCdStoreGet(cdStore: number, dtFrom?: Date, dtTo?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<StorePayingOutputDto>>;
    public apiStorePayingGetStoreLiquidationsCdStoreGet(cdStore: number, dtFrom?: Date, dtTo?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<StorePayingOutputDto>>>;
    public apiStorePayingGetStoreLiquidationsCdStoreGet(cdStore: number, dtFrom?: Date, dtTo?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<StorePayingOutputDto>>>;
    public apiStorePayingGetStoreLiquidationsCdStoreGet(cdStore: number, dtFrom?: Date, dtTo?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cdStore === null || cdStore === undefined) {
            throw new Error('Required parameter cdStore was null or undefined when calling apiStorePayingGetStoreLiquidationsCdStoreGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (dtFrom !== undefined && dtFrom !== null) {
            queryParameters = queryParameters.set('dtFrom', <any>dtFrom.toISOString());
        }
        if (dtTo !== undefined && dtTo !== null) {
            queryParameters = queryParameters.set('dtTo', <any>dtTo.toISOString());
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<StorePayingOutputDto>>('get',`${this.basePath}/api/StorePaying/GetStoreLiquidations/${encodeURIComponent(String(cdStore))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiStorePayingPostPost(body?: StorePayingInputDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiStorePayingPostPost(body?: StorePayingInputDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiStorePayingPostPost(body?: StorePayingInputDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiStorePayingPostPost(body?: StorePayingInputDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/api/StorePaying/Post`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
